import { useModal } from "../../../../hooks/useModal";
import AddressModal from "../../../Shipping/AddressModal";
import ButtonUI from "../../../UI/ButtonUI/ButtonUI";

export default function AddressAdd() {
    const { isModalOpen, openModal, closeModal } = useModal();

    return (
        <div className="address-add">
            <ButtonUI text="Добавить адрес" theme="rect" onClick={openModal} />
            <AddressModal 
                isModalOpen={isModalOpen} 
                closeModal={closeModal}
            />
        </div>
    );
}